export default __webpack_public_path__ + "static/media/notesAlterations_fr.6b0d0bdc.png";